import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchExcursionTypes = async ({ rootGetters, commit }, { params, clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getExcursionTypes(params, clientSid);
  if (response.excursionTypes) {
    commit('setExcursionTypes', response.excursionTypes);
  }
  return response;
};
